import { View, StyleSheet, ScrollView } from "react-native";
import { useUISlice } from "@/models/useUISlice";
import ModalContainer from "@/ui/ModalContainer";
import { ms } from "@/ui/moderateScale";
import { useTranslation } from "react-i18next";
import { Colors } from "@/constants";
import PrimaryButton from "@/ui/PrimaryButton";
import Input from "@/ui/Input";
import { useEffect, useState } from "react";
import CheckboxButton from "./CheckboxButton";
import { useUserSlice } from "@/models/useUserSlice";

const AlertWidgetAIContentEditWithAI = () => {
  const visible = useUISlice((state) => state.alertWidgetAIContentEditWithAI);
  const setVisible = useUISlice(
    (state) => state.setAlertWidgetAIContentEditWithAI
  );
  const height = useUISlice((state) => state.device.height);
  const [loading, setLoading] = useState(false);
  const [saveUpdates, setSaveUpdates] = useState(false);
  const width = useUISlice((state) => state.device.width);
  const [text, setText] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (visible?.userTemplateId && visible.userTemplateId === "summary") {
      const user = useUserSlice.getState().userData;
      setText(user?.summaryPrompt || "");
    }
  }, [visible]);

  if (!visible) return null;

  const onApplyChanges = async () => {
    if (!text.trim()) {
      useUserSlice.getState().user().update({ summaryPrompt: "" });
      onDismiss();
      return;
    }

    setLoading(true);

    await useUserSlice
      .getState()
      .note()
      .editWithAI(
        visible.noteId,
        visible.userTemplateId,
        text.trim(),
        saveUpdates
      );

    setLoading(false);
    onDismiss();
  };

  const onDismiss = () => {
    setText("");
    setSaveUpdates(false);
    setVisible(undefined);
  };

  return (
    <ModalContainer
      title={visible?.title || t("alertWidgetAIContentEditWithAI.title")}
      onDismiss={onDismiss}
      hideCancel
      autoFocus
      modalWidth={Math.min(width, 600)}
    >
      <ScrollView>
        <View style={styles.spacer} />
        <Input
          autoFocus
          label=""
          value={text}
          height={height * 0.4}
          onTextChange={(text) => {
            setText(text);
          }}
          multiLine
          placeholder={t("alertWidgetAIContentEditWithAI.editPlaceholder")}
        />

        {/* <View style={styles.spacer} />
        <CheckboxButton
          value={saveUpdates}
          title={t("alertWidgetAIContentEditWithAI.checkboxTitle")}
          onCheckboxChange={(active) => {
            setSaveUpdates(active);
          }}
        /> */}
        <View style={styles.largerSpacer} />
      </ScrollView>

      <PrimaryButton
        text={t("alertWidgetAIContentEditWithAI.buttonText")}
        onPress={onApplyChanges}
        loading={loading}
      />
    </ModalContainer>
  );
};

const styles = StyleSheet.create({
  spacer: {
    height: ms(16),
  },
  largerSpacer: {
    height: ms(32),
  },
  label: {
    paddingHorizontal: ms(24),
    fontSize: ms(16),
    fontWeight: "400",
    color: Colors.text,
    marginBottom: ms(8),
  },
  negativeMargin: {
    marginBottom: -ms(16),
  },
});

export default AlertWidgetAIContentEditWithAI;
